import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

export const FinalizacaoRoute = () => {
  const { user } = useAuth();

  if (!user?.token) return <Navigate to="/login" replace />;

  if (user.tipusu === "FORNECEDOR" && user.status === "QUESTIONARIO_PENDENTE") {
    return <Outlet />; 
  } else {
    return <Navigate to="/home" replace />;
  }
};
